import useMediaQuery from "@material-ui/core/useMediaQuery";

export const HookImports_useMediaQuery = useMediaQuery;

export const HookImports_useMediaQuery_theme = useMediaQuery;

